import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";

import { Link } from 'react-router-dom';
import { Button, Dropdown, Modal } from "react-bootstrap";
import { Icon } from '@iconify/react';
import { ClipLoader } from "react-spinners";
import PerfectScrollbar from 'react-perfect-scrollbar';

import CustomToggle from "../../Common/CustomToggle";

import _ from "lodash";

import { applyCategoryToEquipmentUnit, getAllEquipmentUnitCategoriesByProfileId, getEquipmentUnitsByCategory } from "../../../../api";
import { checkForAPISuccess, showErrorToast, showSuccessToast } from "../../../../Common/commonFunctions";

import { DEFAULT_EQUIPMENT_UNIT_NAME, RESPONSE_REPEATING_COMPONENT_TYPES_CODE, useQueryConfiguration } from "../../../../Common/constants";

const ApplyOrViewCategoryToMultipleUnits = props => {

    const [utils, setUtils] = useState({
        showApplyCategoryPopup: false, categoriesInProfile: [], selectedCategoryId: "",
        categoryBasedEquipmentUnits: [], selectedEquipmentUnitIds: [], allEquipmentUnitIds: [],
        isSelectAllEquipmentUnits: false, isRepeatingComponentCategory: false
    });

    const isEditOngoing = useSelector(state => state.equipment.isEditOngoing);
    const isLockedProfile = useSelector(state => state.equipment.isLockedProfile);

    const profileId = window.location.pathname.split("/")[3];

    const fetchCategories = async () => {
        const response = await getAllEquipmentUnitCategoriesByProfileId(profileId);
        return response?.data;
    }

    const fetchCategoriesQuery = useQuery('get-categories', fetchCategories, { ...useQueryConfiguration });

    const fetchEquipmentUnitsByCategory = async () => {
        if(!_.isEmpty(utils.selectedCategoryId)) {
            const response = await getEquipmentUnitsByCategory(utils.selectedCategoryId);
            if(checkForAPISuccess(response?.data?.statusCode)) {
                let allEquipmentUnitIds = [];
                Object.keys(response?.data?.data).forEach(equipmentName => {
                    response?.data?.data?.[equipmentName]?.forEach(equipmentUnit => {
                        allEquipmentUnitIds.push(equipmentUnit?.id);
                    });
                })
                setUtils({
                    ...utils, categoryBasedEquipmentUnits: response?.data?.data,
                    allEquipmentUnitIds: allEquipmentUnitIds, isRepeatingComponentCategory: false 
                });
            }
            else if(response?.data?.statusCode === RESPONSE_REPEATING_COMPONENT_TYPES_CODE) {
                setUtils({
                    ...utils,  isRepeatingComponentCategory: true, categoryBasedEquipmentUnits: [],
                    selectedEquipmentUnitIds: [], allEquipmentUnitIds: [], isSelectAllEquipmentUnits: false
                });
            }
            else {
                showErrorToast("Failed to fetch categories under this profile");
                setUtils({ 
                    ...utils, categoryBasedEquipmentUnits: [], selectedEquipmentUnitIds: [],
                    allEquipmentUnitIds: [], isSelectAllEquipmentUnits: false, isRepeatingComponentCategory: false
                });
            }
        }
    }

    const fetchEquipmentUnitsByCategoryQuery = useQuery(
        ['get-equipment-units-by-category', utils.selectedCategoryId],
        fetchEquipmentUnitsByCategory,
        { ...useQueryConfiguration, enabled: !_.isEmpty(utils.selectedCategoryId) }
    );

    const applyCategory = async () => {
        const response = await applyCategoryToEquipmentUnit({
            categoryId: utils.selectedCategoryId,
            equipmentUnitId: utils.selectedEquipmentUnitIds,
            isMultipleEquipmentUnitApply: true
        });
        return response?.data;
    }

    const applyCategoryToEquipmentUnitsQuery = useQuery('apply-category-to-equipment-units', applyCategory, { ...useQueryConfiguration });

    const addOrRemoveEquipmentUnitId = (id) => {
        let updatedEquipmentUnitIds = _.clone(utils.selectedEquipmentUnitIds);
        if(updatedEquipmentUnitIds.includes(id)) {
            updatedEquipmentUnitIds.splice(updatedEquipmentUnitIds.indexOf(id), 1);
        }
        else {
            updatedEquipmentUnitIds.push(id);
        }
        setUtils({ ...utils, selectedEquipmentUnitIds: updatedEquipmentUnitIds, isSelectAllEquipmentUnits: false });
    }

    useEffect(() => {
        fetchCategoriesQuery.refetch();
    }, []);

    useEffect(() => {
        if(fetchCategoriesQuery.isFetched) {
            if(checkForAPISuccess(fetchCategoriesQuery?.data?.statusCode)) {
                setUtils({ ...utils, categoriesInProfile: fetchCategoriesQuery?.data?.data?.categories });
            }
            else {
                showErrorToast("Failed to fetch categories under this profile");
            }
            fetchCategoriesQuery.remove();
        }
        if(applyCategoryToEquipmentUnitsQuery.isFetched) {
            if(checkForAPISuccess(applyCategoryToEquipmentUnitsQuery?.data?.statusCode)) {
                setUtils({
                    ...utils, selectedCategoryId: "", 
                    categoryBasedEquipmentUnits: [], selectedEquipmentUnitIds: [], 
                    allEquipmentUnitIds: [], isSelectAllEquipmentUnits: false 
                });
                showSuccessToast("Category applied successfully");
                window.location.reload();
            }
            else {
                showErrorToast("Failed to apply category");
            }
            applyCategoryToEquipmentUnitsQuery.remove();
        }
    }, [fetchCategoriesQuery.isFetched, applyCategoryToEquipmentUnitsQuery.isFetched]);

    return (
        <>
            <Dropdown drop="left">
                <Dropdown.Toggle as={CustomToggle}>
                    {
                        !isEditOngoing && !isLockedProfile &&
                            <Icon
                                className={"cursor-pointer"}
                                width={20} height={20} color={"#075978"}
                                icon={'feather-more-vertical'}
                            />
                    }
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    <Dropdown.Item className="category-dropdown-option">
                        <Link style={{ color: "#075978" }} to={{ pathname: `/equipment-unit-categories/${profileId}` }}>
                            View equipment unit categories
                        </Link>
                    </Dropdown.Item>
                    <Dropdown.Item 
                        onClick={() => setUtils({ ...utils, showApplyCategoryPopup: true })} 
                        className="category-dropdown-option"
                    >
                        Apply equipment unit category
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
            <Modal backdrop="static" show size="xl" onHide={() => props.closePopup()}>
                <Modal.Header closeButton>
                    <h5>
                        <b>Apply category</b>
                    </h5>
                </Modal.Header>
                <Modal.Body style={{ height: "65vh", width: "100%" }}>
                    {
                        fetchCategoriesQuery.isFetching || applyCategoryToEquipmentUnitsQuery.isFetching ?
                            <div className="apply-category-modal-center-align">
                                <ClipLoader color="#075978"/>
                            </div>
                                :
                            <div className="h-100">
                                {
                                    !_.isEmpty(utils.categoriesInProfile) ?
                                        <div className="flex-space-even h-100">
                                            <div className="w-50">
                                                <PerfectScrollbar>
                                                    {
                                                        utils.categoriesInProfile.map(category => 
                                                            <div
                                                                key={category.id}
                                                                className={
                                                                    `pl-3 pr-3 apply-category-modal-item 
                                                                    ${utils.selectedCategoryId === category.id ? "selected-category" : ""}
                                                                    ${fetchEquipmentUnitsByCategoryQuery.isFetching ? "disable-click" : ""}`
                                                                }
                                                                onClick={() => setUtils({
                                                                        ...utils,
                                                                        selectedCategoryId: category.id,
                                                                        isSelectAllEquipmentUnits: false,
                                                                        selectedEquipmentUnitIds: [],
                                                                        categoryBasedEquipmentUnits: [],
                                                                        allEquipmentUnitIds: []
                                                                    })
                                                                }
                                                            >
                                                                <div className="text-ellipsis">
                                                                    {category?.name}
                                                                </div>
                                                                <div className="text-color-grey text-ellipsis">
                                                                    {category?.components}
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                </PerfectScrollbar>
                                            </div>
                                            <div style={{ borderLeft: "1px solid #eaeaea" }} className="w-50">
                                                {
                                                    fetchEquipmentUnitsByCategoryQuery.isFetching ?
                                                        <div className="apply-category-modal-center-align">
                                                            <ClipLoader color="#075978" />
                                                        </div>
                                                            :
                                                        utils.isRepeatingComponentCategory ?
                                                            <div className="apply-category-modal-center-align">
                                                                SELECTED CATEGORY HAS SOME REPEATING COMPONENT TYPES
                                                            </div>
                                                                :
                                                            !_.isEmpty(utils.categoryBasedEquipmentUnits) ?
                                                                <>
                                                                    <PerfectScrollbar style={{ height: "90%" }}>
                                                                        {
                                                                            Object.keys(utils.categoryBasedEquipmentUnits).map(equipmentName =>
                                                                                <>
                                                                                    {
                                                                                        !_.isEmpty(utils.categoryBasedEquipmentUnits[equipmentName]) &&
                                                                                            <div
                                                                                                key={equipmentName} 
                                                                                                style={{ borderBottom: "1px solid #eaeaea" }} 
                                                                                                className="pl-3 my-3"
                                                                                            >
                                                                                                <b className="my-3">{equipmentName}</b>
                                                                                                {
                                                                                                    utils.categoryBasedEquipmentUnits[equipmentName].map(equipmentUnit =>
                                                                                                        <div key={equipmentUnit.id} className="vertical-center-align my-2">
                                                                                                            <input
                                                                                                                checked={utils.selectedEquipmentUnitIds.includes(equipmentUnit.id)}
                                                                                                                onChange={(e) => addOrRemoveEquipmentUnitId(equipmentUnit.id)}
                                                                                                                id={equipmentUnit.id} type="checkbox" className="mr-2 w-15-h-15"
                                                                                                            />
                                                                                                            <label for={equipmentUnit.id} className="mt-2 cursor-pointer">
                                                                                                                {
                                                                                                                    equipmentUnit?.name === DEFAULT_EQUIPMENT_UNIT_NAME ?
                                                                                                                        "--"
                                                                                                                            :
                                                                                                                        equipmentUnit?.name
                                                                                                                }
                                                                                                            </label>
                                                                                                        </div>
                                                                                                    )
                                                                                                }
                                                                                            </div>
                                                                                    }
                                                                                </>
                                                                            )
                                                                        }
                                                                    </PerfectScrollbar>
                                                                    <div className="select-all-apply-category-modal my-2 pl-3">
                                                                        <input
                                                                            checked={utils.isSelectAllEquipmentUnits}
                                                                            id="select-all"
                                                                            onChange={(e) => {
                                                                                if(e.target.checked) {
                                                                                    setUtils({
                                                                                        ...utils,
                                                                                        selectedEquipmentUnitIds: _.clone(utils.allEquipmentUnitIds),
                                                                                        isSelectAllEquipmentUnits: true
                                                                                    })
                                                                                }                                                                            
                                                                            }}
                                                                            type="checkbox" className="mr-2 w-15-h-15" 
                                                                        />
                                                                        <label for='select-all' className="mt-2 cursor-pointer">
                                                                            <b>Click here to select all equipment units</b>
                                                                        </label>
                                                                    </div>
                                                                </>
                                                                    :
                                                                <div className="apply-category-modal-center-align">
                                                                    NO EQUIPMENT UNITS SIMILAR TO SELECTED CATEGORY WERE FOUND
                                                                </div>
                                                }
                                            </div>
                                        </div>
                                            :
                                        <b className="my-4 vertical-center-align justify-center h-100">
                                            NO CATEGORIES FOUND UNDER THE PROFILE
                                        </b>
                                }
                            </div>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        className="secondary-button"
                        disabled={
                            fetchEquipmentUnitsByCategoryQuery.isFetching ||
                            fetchCategoriesQuery.isFetching
                        }
                        onClick={() => props.closePopup()}
                    >
                        Cancel
                    </Button>
                    <Button
                        disabled={
                            fetchEquipmentUnitsByCategoryQuery.isFetching ||
                            fetchCategoriesQuery.isFetching ||
                            _.isEmpty(utils.selectedEquipmentUnitIds)
                        }
                        onClick={() => applyCategoryToEquipmentUnitsQuery.refetch()}
                    >
                        Apply
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )

}

export default ApplyOrViewCategoryToMultipleUnits;